/**
 * Cookku Recently Viewed Products
 * - Tracks product handles in localStorage
 * - Renders 4 cards in section markers
 */
(function () {
  if (window.__cookkuRecentlyViewedBound) return;
  window.__cookkuRecentlyViewedBound = true;

  const STORAGE_KEY = 'cookku_recently_viewed_v1';
  const MAX_TRACKED = 16;
  const DEFAULT_LIMIT = 6;

  const readList = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (err) {
      return [];
    }
  };

  const writeList = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (err) { /* ignore */ }
  };

  /* Push current product handle (if on product page) */
  const trackCurrent = () => {
    const meta = document.querySelector('meta[name="cookku-product-handle"]');
    const handle = meta && meta.content;
    if (!handle) return;
    const list = readList().filter((h) => h !== handle);
    list.unshift(handle);
    writeList(list.slice(0, MAX_TRACKED));
  };

  /* Build card HTML for a product (Storefront /products/{handle}.js response) */
  const buildCard = (product) => {
    if (!product || !product.handle) return '';
    const image = (product.featured_image || product.images && product.images[0] || '');
    const imageUrl = image
      ? image.replace(/(\.(?:jpg|jpeg|png|webp|gif))/i, '_400x$1')
      : '';
    const price = product.price != null ? product.price : 0;
    const compare = product.compare_at_price || 0;
    const onSale = compare > price;
    const moneyFormat = (cents) => {
      const n = (cents / 100).toFixed(2);
      return `$${n}`;
    };
    const savePercent = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
    const available = product.available !== false;

    return `
      <article class="cookku-recent-card">
        <a class="cookku-recent-card__media" href="/products/${product.handle}" aria-label="${escapeHtml(product.title)}">
          ${onSale ? '<span class="cookku-recent-card__badge">Sale</span>' : ''}
          ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy" width="300" height="300">` : '<div class="cookku-recent-card__placeholder"></div>'}
        </a>
        <div class="cookku-recent-card__body">
          <h3 class="cookku-recent-card__title"><a href="/products/${product.handle}">${escapeHtml(product.title)}</a></h3>
          <div class="cookku-recent-card__price-row">
            <span class="cookku-recent-card__price">${moneyFormat(price)}</span>
            ${onSale ? `<span class="cookku-recent-card__compare">${moneyFormat(compare)}</span>` : ''}
            ${onSale ? `<span class="cookku-recent-card__save">Save ${savePercent}%</span>` : ''}
          </div>
          <a href="/products/${product.handle}" class="cookku-recent-card__cta">${available ? 'View Product →' : 'Sold out'}</a>
        </div>
      </article>
    `;
  };

  const escapeHtml = (str) => {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  };

  /* Render Recently Viewed for a marker element */
  const renderMarker = (marker) => {
    const limit = parseInt(marker.dataset.limit || DEFAULT_LIMIT, 10);
    const excludeHandle = marker.dataset.excludeHandle || '';

    const list = readList()
      .filter((h) => h && h !== excludeHandle)
      .slice(0, limit);

    if (list.length === 0) {
      marker.style.display = 'none';
      return;
    }

    Promise.all(list.map(fetchProduct))
      .then((products) => {
        const valid = products.filter((p) => p && p.handle);
        if (valid.length === 0) {
          marker.style.display = 'none';
          return;
        }
        const grid = marker.querySelector('[data-cookku-recent-grid]');
        if (!grid) return;
        grid.innerHTML = valid.map(buildCard).join('');
        marker.style.display = '';
        marker.classList.add('is-ready');
      })
      .catch((err) => {
        console.error('[Cookku] Recently viewed render error:', err);
        marker.style.display = 'none';
      });
  };

  const init = () => {
    trackCurrent();
    document.querySelectorAll('[data-cookku-recently-viewed]').forEach(renderMarker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
